let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5H9Jz")).then(() => parcelRequire('ccyLS'));